import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import React from 'react';

const structuredData = {
  "@context": "https://schema.org",
  "@type": "OfferCatalog",
  "name": "Background Check Services Pricing",
  "url": "https://www.homecarechecks.com/pricing",
  "provider": {
    "@type": "Organization",
    "name": "RealTech LLC",
    "url": "https://www.homecarechecks.com"
  },
 "itemListElement": [
  {
    "@type": "Offer",
    "itemOffered": { "@type": "Service", "name": "7-Year Criminal History" },
    "price": "15.00", "priceCurrency": "USD"
  },
  {
    "@type": "Offer",
    "itemOffered": { "@type": "Service", "name": "Continuous Criminal Monitoring" },
    "price": "20.00", "priceCurrency": "USD"
  },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "DHHS" }, "price": "1.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "EVerify" }, "price": "3.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "ICOTS" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL DFPR License Search" }, "price": "1.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL Health Care Worker Registry" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL Inmate Search" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL Parolee Sex Registrant" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL Sex Offender" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "IL Wanted Fugitives" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "KY License Lookup" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "KY Misconduct Registry" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Medicaid Excluded List" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "MO EDL" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "Motor Vehicle Report (MVR)" }, "price": "15.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "MS Nurse Aide Registry" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "National Sex Offender" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OH Abuse Registry" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OH Exclusion List" }, "price": "1.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OH Nurse Aide Search" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OH Offender Search" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OH Sex Offender Search" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "OIG/HHS" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SAM/GSA" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SIRI" }, "price": "0.00", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "SSN Verification" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Abuse" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Drug Offender" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Felony Offender" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Hamilton County Search" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Howard Criminal" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Sex Offender" }, "price": "0.50", "priceCurrency": "USD" },
  { "@type": "Offer", "itemOffered": { "@type": "Service", "name": "TN Terminated Provider List" }, "price": "0.50", "priceCurrency": "USD" }
]
};

export default function Pricing() {
  return (
    <main>
	<Header
  title="Simple & Transparent Pricing | No Monthly Fees | FortiTeam Pricing"
  description="No subscriptions, no surprise charges. See every background check cost clearly, with real-time billing. Built for homecare agencies that value trust."
  structuredData={structuredData}
/>
	<HeroSection
  heading="Simple & Honest Pricing"
  subheading="No Setup Fees - No Monthly Fees - No Surprise Charges"
  tagline="Only Pay for the Checks You Need"
/>
      <section className="features">
        <div className="founder-quote">
          <img src="/assets/images/joseph-bosas.jpg" alt="Joseph Bosas" />
          <blockquote>
            “…because we believe in charging what we say we will.”<br />
            <span>– Joseph Bosas, Founder</span>
          </blockquote>
        </div>

        <div className="welcome-gift">
          <h3>🎁 Welcome Gift</h3>
          <p>All new clients receive a <strong>custom-branded Yeti</strong> after their first paid invoice.</p>
              </div>
              <div className="welcome-gift">
                  <h3>Discounts</h3>
                  <p>We offer 10% discount for 6 months after a referral's first paid invoice. The 10% can overlap to add up to 100% off. Each 10% discounted amount is taken off after data access/regulatory fees (e.g. MVR state fees, court records access fees, etc.).</p>
              </div>
	</section>
	<section class="features">
  <h2>What are some of my options?</h2>
  <ul>
    <li><strong>7-Year Criminal History Search</strong> – National coverage for felony and misdemeanor records</li>
    <li><strong>Continuous Criminal Monitoring</strong> – Ongoing alerts if your caregivers are arrested</li>
    <li><strong>Healthcare Exclusion & Abuse Registry Checks</strong> – Medicaid/OIG/SAM compliance at your fingertips</li>
    <li><strong>License & Credential Verification</strong> – Validate nurse aide, professional, and caregiver licenses</li>
    <li><strong>Motor Vehicle Reports (optional)</strong> – Ensure safe drivers for client transportation</li>
  </ul>
  <p><em>Every report is designed for <strong>homecare agency compliance</strong>—covering federal and state-specific requirements.</em></p>
</section>
      <section className="features">
       <table class="pricing-table-list">
		  <thead>
			<tr><th>Background Check</th><th>Fee</th></tr>
		  </thead>
		  <tbody>
			<tr><td colspan="2"><strong>Core Background Checks</strong></td></tr>
			<tr><td>7-Year Criminal History</td><td>$15.00</td></tr>
			<tr><td>Continuous Criminal Monitoring</td><td>$20.00 (per yr.)</td></tr>
			<tr><td>SSN Verification</td><td>$0.50</td></tr>

			<tr><td colspan="2"><strong>Healthcare Exclusion Lists</strong></td></tr>
			<tr><td>Medicaid Excluded List</td><td>$0.50</td></tr>
			<tr><td>OIG/HHS</td><td>$0.50</td></tr>
			<tr><td>SAM/GSA</td><td>$0.50</td></tr>
			<tr><td>State Abuse Registries (TN, OH, MS, etc.)</td><td>$0.50–$1.00</td></tr>

			<tr><td colspan="2"><strong>License & Registry Checks</strong></td></tr>
			<tr><td>IL DFPR License Search</td><td>$1.00</td></tr>
			<tr><td>KY License Lookup</td><td>$0.50</td></tr>
			<tr><td>Nurse Aide Registries (IL, MS, OH, etc.)</td><td>$0.50</td></tr>

			<tr><td colspan="2"><strong>Sex Offender & Criminal Registries</strong></td></tr>
			<tr><td>National Sex Offender</td><td>$0.50</td></tr>
			<tr><td>State Offender/Parolee/Fugitive Lists</td><td>$0.50</td></tr>

			<tr><td colspan="2"><strong>Motor Vehicle Reports</strong></td></tr>
			<tr><td>MVR*</td><td>$15.00 + state fees</td></tr>
		  </tbody>
		</table>
		<p style={{ fontSize: '0.9rem', marginTop: '1rem' }}><em>* State-imposed MVR access fees may apply in addition to the amount stated. Contact us for state-specific pricing.</em></p>
        <p style={{ fontSize: '0.9rem', marginTop: '1rem' }}>
          <em>* Each state imposes a Motor Vehicle Report access fee that may apply in addition to the amount stated. Contact us for state-specific MVR pricing.</em>
        </p>
      </section>
    </main>
  );
}
